export const resolvePromise = async <T>(promise: Promise<T>) => {
	try {
		const data = await promise;
		return [data, null] as [T, null];
	} catch (error) {
		return [null, error] as [null, any];
	}
};
